import React from "react";
import { companyInfo } from "../data/mock";
import { MessageCircle } from "lucide-react";
import { Button } from "./ui/button";

export const WhatsAppSection = () => {
  return (
    <section className="py-20 md:py-24 bg-emerald-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative bg-white rounded-3xl shadow-xl shadow-emerald-900/[0.06] p-10 md:p-16 overflow-hidden">
          {/* Decorative */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-100/50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-teal-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-10">
            {/* Content */}
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 bg-[#25D366]/10 rounded-full px-4 py-1.5 mb-5">
                <MessageCircle className="w-4 h-4 text-[#25D366]" />
                <span className="text-[#128C7E] text-sm font-semibold">
                  WhatsApp Support
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight mb-4">
                Need Quick Support?{" "}
                <span className="text-[#25D366]">Chat With Us Instantly</span>
              </h2>
              <p className="text-slate-500 text-lg leading-relaxed mb-6">
                Get quick quotes, book pickups, and track your scrap collection directly
                through WhatsApp. We're available 24/7 for your convenience.
              </p>

              <div className="flex flex-wrap gap-3 mb-8">
                {["Quick Enquiry", "Pickup Booking", "Follow-ups", "24/7 Response"].map(
                  (tag, i) => (
                    <span
                      key={i}
                      className="px-4 py-2 bg-emerald-50 text-emerald-700 text-sm font-medium rounded-lg"
                    >
                      {tag}
                    </span>
                  )
                )}
              </div>

              <a
                href={`https://wa.me/${companyInfo.whatsapp}?text=Hi%20AM%20Scrap%20Dealers%2C%20I%20need%20assistance%20with%20scrap%20pickup.`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  size="lg"
                  className="bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-xl px-8 py-6 text-base font-semibold shadow-xl shadow-green-900/15 transition-all duration-300 hover:-translate-y-0.5"
                >
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Chat on WhatsApp
                </Button>
              </a>
            </div>

            {/* Visual */}
            <div className="flex-shrink-0">
              <div className="w-56 h-56 md:w-64 md:h-64 bg-[#25D366]/10 rounded-3xl flex items-center justify-center">
                <MessageCircle className="w-24 h-24 text-[#25D366]/60" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
